import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
// material
import { Link, Stack, Checkbox, TextField, IconButton, InputAdornment, FormControlLabel } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// component
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

export default function TopUpForm() {
  const navigate = useNavigate();
  const [btn, setBtn] = useState("Top Up");
  const [showPassword, setShowPassword] = useState(false);
  const [user, setUser] = useState(
    {
      "status": true,
      "message": "Login successful!",
      "data": {
          "rating": "0",
          "availability": "offline",
          "status": true,
          "role": "artisan",
          "_id": "6303b359ae52850016ba2d95",
          "phone": "9135403118",
          "country_code": "234",
          "id": "6303b359ae52850016ba2d95",
          "token": "UEC2EAmYK3h31ssVRWLD8MQjQOapqo",
          "createdAt": "2022-08-22T16:48:25.655Z",
          "updatedAt": "2022-09-01T23:51:54.155Z",
          "__v": 0,
          "address_str": "10 Juliest ultimate Drive",
          "avatar": "avatar",
          "email": "omonicksonowoeye@gmail.com",
          "first_name": "Omoniyi",
          "last_name": "Omoniyi",
          "location": {
              "type": "Point",
              "coordinates": [
                  7.471104,
                  9.0570752
              ],
              "_id": "6311442da0ebe3001607e006"
          },
          "password": "bml5aW5peWk=",
          "username": "worldest",
          "video": "avatar"
      }
    }
  );
  const LoginSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    password: Yup.string().required('Password is required'),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      remember: true,
    },
    validationSchema: LoginSchema,
    onSubmit: () => {
      navigate('/dashboard', { replace: true });
    },
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  useEffect(() => {
    const getUser = localStorage.getItem("user");
    const user_ = localStorage.getItem("user");
    setUser(JSON.parse(user_))
  }, [])
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={(e) => {
        e.preventDefault();
        setBtn("Please Wait...")
        const body = {
          fullname: user.data.first_name,
          email: user.data.email,
          amount:  document.getElementById("amount").value,
        };
        fetch(`https://keyedin-nodejs.herokuapp.com/api/v1/wallets/initialize-payment-gateway`, {
          body: JSON.stringify(body),
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(resposne => resposne.json())
        .then(data => {
          console.log(data);
          window.location.href = data.data.authorization_url
        })
        .catch(err => {
          alert(`Error: ${err}`);
          setBtn("")
        })
      }}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            type="number"
            id="amount"
            label="Enter Amount"
            required
          />

          
        </Stack>

        <br />

        <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          {btn}
        </LoadingButton>
        
      </Form>
      <br />
      <hr />
      <br />
      <LoadingButton fullWidth size="large" variant="contained">
        Bank Details
    </LoadingButton>
    </FormikProvider>
  );
}
